import { render, staticRenderFns } from "./addClasses.vue?vue&type=template&id=5594f825&"
import script from "./addClasses.vue?vue&type=script&lang=js&"
export * from "./addClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports